import { IHallBooking } from "src/domain/entities"
import { hallBookingListApi } from "../../api/hallBooking/hallBookingListApi"

type PayloadShape = Parameters<typeof hallBookingListApi>[0]

export async function hallBookingListService(
	payload: PayloadShape,
	token?: null | string,
) {
	const hallBookings = await hallBookingListApi(payload, token)
	return hallBookings as NonNullable<IHallBooking[]>
}
